/**
 * @file 语种相关方法
 * @author svon.me@gmail.com
 **/

import * as config from "src/config";
import * as cookie from "./brower/cookie";

const keyName = "APP_LANG";

export enum LanguageType {
  Chinese = "zh-cn",
  English = "en",
  HkChinese = "hk",
  Korean = "ka",
  Japanese = "ja"
}

export const autoType = function(): string {
  return String(config.Language || LanguageType.Chinese).trim();
}

// 当前语种
export const currentType = function (): string {
  let value = cookie.get(keyName);
  if (!value) {
    value = autoType();
    changeType(value);
  }
  return String(value).trim();
}

// 切换语种
export const changeType = function (value: string | LanguageType): boolean {
  let status: boolean = false;
  switch (value) {
    case LanguageType.Chinese:
    case LanguageType.English:
    case LanguageType.HkChinese:
    case LanguageType.Korean:
    case LanguageType.Japanese:
      status = true;
      break;
  }
  if (status) {
    cookie.set(keyName, value);
  }
  return status;
}